import React from "react";
import { Spinner } from "@components/common/Spinner";
export var MainSearchBarSuggestionsLoading = React.memo(function () {
    return (React.createElement("div", { className: "p-4 shadow-xl rounded-[0.625rem] bg-white" },
        React.createElement(Spinner, { size: "large", className: "mx-auto" })));
});
